import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Dropdown, IDropdownStyles } from '@fluentui/react/lib/Dropdown';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import {
	IStackItemStyles,
	IStackTokens,
	Stack,
} from '@fluentui/react/lib/Stack';
import { Text } from '@fluentui/react/lib/Text';
import { TextField, ITextFieldStyles } from '@fluentui/react/lib/TextField';
import { IUser, IDictItem, IStore } from '../../schemas';
import { PrimaryButton } from '@fluentui/react/lib/Button';
import * as OPTIONS from '../options';

const stackTokens: IStackTokens = {
	childrenGap: 5,
};

const stackItemStyles: IStackItemStyles = {
	root: {
		flex: 1,
	},
};

const verticalStackTokens: IStackTokens = {
	childrenGap: 5,
};

const textFieldSytles: Partial<ITextFieldStyles> = {
	field: {
		color: '#000',
	},
	subComponentStyles: {
		label: {
			root: { fontWeight: 'normal', color: '#484644' },
		},
	},
};

const dropdownStyles: Partial<IDropdownStyles> = {
	title: { color: '#484644' },
	label: {
		fontWeight: 'normal',
		color: '#484644',
	},
	subComponentStyles: {
		label: {
			root: { fontWeight: 'normal', color: '#484644' },
		},
		panel: {},
		multiSelectItem: {},
	},
};

const buttonStyle = {
	root: {
		marginLeft: 8,
		border: 'none',
	},
};

class UserPanelDetail extends Component<any, any> {
	closePanel = () => {
		this.props.onDismiss(false);
	};

	/**
	 * @returns Panel footer component
	 */
	onRenderFooterContent = () => {
		return null;
	};

	render() {
		const { detail, dictionary } = this.props;

		return (
			<>
				<Panel
					isOpen={this.props.isOpen}
					onDismiss={this.closePanel}
					onRenderFooterContent={this.onRenderFooterContent}
					type={PanelType.medium}
					headerText='User Details'
					isFooterAtBottom={true}
					styles={{
						navigation: { backgroundColor: '#f5f5f5' },
						main: {
							backgroundColor: '#f5f5f5',
						},
						commands: { zIndex: '9999' },
					}}
				>
					<Stack tokens={verticalStackTokens}>
						<Stack horizontal tokens={stackTokens}>
							<Stack.Item grow>
								<TextField
									key='txtUserName'
									label='User Name'
									disabled
									borderless
									styles={textFieldSytles}
									value={detail.userName}
								/>
							</Stack.Item>

							<Stack.Item grow>
								<TextField
									key='txtUserEmail'
									label='Email'
									disabled
									borderless
									styles={textFieldSytles}
									value={detail.userEmail}
								/>
							</Stack.Item>
						</Stack>

						<Stack horizontal tokens={stackTokens}>
							<Stack.Item grow={1} styles={{ root: { width: '50%' } }}>
								<Dropdown
									key='dpTeam'
									label='Team'
									options={dictionary.teams.map((item) => {
										return { key: item.itemValue, text: item.itemName };
									})}
									styles={dropdownStyles}
									selectedKey={detail.team}
									disabled
								/>
							</Stack.Item>

							<Stack.Item grow={1} styles={{ root: { width: '50%' } }}>
								<Dropdown
									key='dpRole'
									label='Role'
									options={OPTIONS.roleOptions}
									styles={dropdownStyles}
									selectedKey={detail.role}
									disabled
								/>
							</Stack.Item>
						</Stack>
					</Stack>
				</Panel>
			</>
		);
	}
}

export default connect((state: IStore) => ({
	dictionary: state.dictionary,
}))(UserPanelDetail);
